import ComponentFactory from './ComponentFactory';
import Icons from './utils/Icons';
import ServiceBoxHeight from './components/ServiceBoxHeight';
//import 'bootstrap';

class Main {
  constructor() {
    this.init();
  }

  init() {
    document.documentElement.classList.add('has-js');

    new ComponentFactory();
    Icons.load();

    // Initialiser ServiceBoxHeight automatiquement si des service-box existent
    if (document.querySelector('.service-box')) {
      new ServiceBoxHeight(document.body);
    }
  }
}
new Main();
